// Batisur — Web Push subscription helper
import { apiClient } from "@/lib/api";

const VAPID_PUBLIC = process.env.REACT_APP_VAPID_PUBLIC_KEY || "";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) output[i] = rawData.charCodeAt(i);
  return output;
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window &&
    !!VAPID_PUBLIC
  );
}

export function currentPushPermission() {
  return typeof Notification !== "undefined" ? Notification.permission : "default";
}

export async function subscribeToPush() {
  if (!isPushSupported()) throw new Error("Push non supporté par ce navigateur.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permission refusée par l'utilisateur.");
  const reg = await navigator.serviceWorker.ready;
  let subscription = await reg.pushManager.getSubscription();
  if (!subscription) {
    subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC),
    });
  }
  await apiClient.post("/notifications/subscribe", {
    subscription: {
      ...subscription.toJSON(),
      _ua: navigator.userAgent.slice(0, 200),
    },
  });
  return subscription;
}

export async function unsubscribeFromPush() {
  if (!isPushSupported()) return false;
  const reg = await navigator.serviceWorker.ready;
  const subscription = await reg.pushManager.getSubscription();
  if (subscription) {
    try {
      await apiClient.post("/notifications/unsubscribe", {
        endpoint: subscription.endpoint,
      });
    } catch {}
    await subscription.unsubscribe();
  }
  return true;
}

export async function isCurrentlySubscribed() {
  if (!isPushSupported()) return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    const subscription = await reg.pushManager.getSubscription();
    return !!subscription;
  } catch {
    return false;
  }
}

export async function sendTestPush() {
  await apiClient.post("/notifications/test-push", {});
}
